// extracted by mini-css-extract-plugin
module.exports = {"root":"root-16EmV","add":"add-2cwld","baggageDirection__root":"baggageDirection__root-2t8WT","baggageCount__root":"baggageCount__root-3GUvr"};